import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Circle, Ticket, BarChart3, List, CreditCard, Table } from "lucide-react";
import { GamificationSpinWheel } from "./gamification/GamificationSpinWheel";
import { GamificationScratchCard } from "./gamification/GamificationScratchCard";
import { GamificationAnalytics } from "./gamification/GamificationAnalytics";
import { GamificationAllSpinWheels } from "./gamification/GamificationAllSpinWheels";
import { GamificationAllScratchCards } from "./gamification/GamificationAllScratchCards";
import { GamificationReport } from "./gamification/GamificationReport";
import { GamificationAllQuizzes } from "./gamification/GamificationAllQuizzes";
import { ListChecks } from "lucide-react";

export default function Gamification() {
  const [activeTab, setActiveTab] = useState<string>("analytics");

  const gamificationTabs = [
    {
      id: "analytics",
      name: "Analytics",
      icon: BarChart3,
    },
    {
      id: "spin-wheel",
      name: "Spin a Wheel",
      icon: Circle,
    },
    {
      id: "all-spin-wheels",
      name: "All Spin Wheels",
      icon: List,
    },
    {
      id: "scratch-card",
      name: "Scratch Card",
      icon: Ticket,
    },
    {
      id: "all-scratch-cards",
      name: "All Scratch Cards",
      icon: CreditCard,
    },
    {
      id: "quiz",
      name: "Quiz",
      icon: ListChecks,
    },
    {
      id: "report",
      name: "Report",
      icon: Table,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Gamification</h1>
          <p className="text-muted-foreground">
            Manage gamification features and activities
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-7">
          {gamificationTabs.map((tab) => (
            <TabsTrigger key={tab.id} value={tab.id} className="text-xs px-2 py-1">
              <tab.icon className="h-4 w-4 mr-2" />
              {tab.name}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="analytics" className="space-y-6">
          <GamificationAnalytics />
        </TabsContent>

        <TabsContent value="spin-wheel" className="space-y-6 mt-6">
          <GamificationSpinWheel />
        </TabsContent>

        <TabsContent value="all-spin-wheels" className="space-y-6 mt-6">
          <GamificationAllSpinWheels />
        </TabsContent>

        <TabsContent value="scratch-card" className="space-y-6 mt-6">
          <GamificationScratchCard />
        </TabsContent>

        <TabsContent value="all-scratch-cards" className="space-y-6 mt-6">
          <GamificationAllScratchCards />
        </TabsContent>
        
        <TabsContent value="quiz" className="space-y-6 mt-6">
          <GamificationAllQuizzes />
        </TabsContent>
        
        <TabsContent value="report" className="space-y-6 mt-6">
          <GamificationReport />
        </TabsContent>
      </Tabs>
    </div>
  );
}
